export class CouponSessionUpdateResult {
  public campaign: string;
  public session: string;
  public action: string;
  public operation: string;
}
